define('pages/map',["jquery", "appquery", "app", "snap", "modules/pathfinder", "panzoom"], function($, $$, App, Snap, pathfinder) {
    $$ = $$('map');

    return {
        init : function(data) {
            var panzoom;
            //info parameter should be passed only from admin

            //Variable declarations
            var self = $$.self();
            var deviceFloor = App.global('map_floor');
            var floorNumbers = data.fromAdmin ? data.info.map_floors : App.global('map_floors').sort(function(a,b){ return b-a; });
            var floors = {};

            floorNumbers.forEach(function(f) {
                floors['floor-' + f] = data.fromAdmin ? data.info['map_floor_' + f] : App.global('map_floor_' + f);
            });
            data.mode = data.mode || 'path';

            var isLocationMode = data.mode =='location';
            var showFloorSwitcher = isLocationMode || data.mode == 'explore';

            //detect device, render svg if desktop else render images
            var renderSVG = isLocationMode && data.fromAdmin ? true : WURFL.form_factor == "Desktop";
            var layoutControl, dimensions, unit, canvas, currentFloor, svgImage = {};

            //Events
            self.on('changefloor', function(e, floor) {
                //update current floor
                currentFloor = floor;

                //Get data for current floor
                floor = floors['floor-' + floor];

                //Update next and prev floor buttons
                var index = floorNumbers.indexOf(currentFloor);
                updateFloorButton('#nextFloor', index + 1);
                updateFloorButton('#prevFloor', index - 1);

                //reset dom and variables
                dimensions = floor.dimensions;
                unit = floor.units;
                canvas = floor.canvas;
                $$('#mapMagnet').replaceWith('\
                    <div id="mapMagnet">\
                        <div class="midalign full"></div>\
                        <div class="midalign" id="mapContainer"></div>\
                    </div>\
                ');

                //Set the dimensions of svg container and append stored svg
                var svgContent = '';
                var pattern = '\
                    <pattern id="grid" width="' + unit.x + '" height="' + unit.y + '" patternUnits="userSpaceOnUse"> \
                        <path id="gridPath" d="M ' + unit.x + ' 0 L 0 0 0 ' + unit.y + '" fill="none" stroke-width="1"/> \
                    </pattern> \
                ';
                var rect = '<rect width="'+dimensions.width+'" height="'+dimensions.height+'" fill="url(#grid)"/>';
                if(renderSVG) {
                    svgContent = floor.svg;
                    if(isLocationMode) {
                        var t = svgContent.split('</defs>');
                        svgContent = t[0] + pattern + '</defs>' + rect + t[1];
                    }
                } else {
                    svgContent = '<svg id="floorMap">' + (isLocationMode ? '<defs>' + pattern + '</defs>' + rect : '') + '</svg>';
                }
                $$('#mapContainer').css({
                    width : dimensions.width + 'px',
                    height : dimensions.height + 'px'
                }).append($(svgContent));

                //Initiate snap on svg
                layoutControl = Snap('#floorMap');

                //If not rendering svg, render image
                if(!renderSVG) {
                    svgImage = {
                        x2 : floor.svg_2x,
                        x3 : floor.svg_3x,
                        x4 : floor.svg_4x,
                        element : layoutControl.image(floor.svg_2x, 0, 0, dimensions.width, dimensions.height)
                    };
                }

                //Initiate panzoom on the svg
                panzoom = $$("#floorMap").svgPanZoom({
                    events: {
                        mouseWheel: true, // enables mouse wheel zooming events
                        doubleClick: true, // enables double-click to zoom-in events
                        drag: true,  // enables panning of svg
                        dragCursor: "move" // cursor to use while dragging the SVG
                    },
                    animationTime: 0,
                    zoomFactor: 0.25,
                    maxZoom: renderSVG ? 10 : 3.9,
                    panFactor: 100,
                    initialViewBox: {
                        x: 0,
                        y: 0,
                        width: dimensions.width,
                        height: dimensions.height
                    },
                    limits: {
                        x: 0,
                        y: 0,
                        x2: dimensions.width,
                        y2: dimensions.height,
                    },
                    onZoom : (function() {
                        var currentImage = 2;
                        return renderSVG ? $.noop : function(zoomFactor) {
                            src = Math.max(2, parseInt(zoomFactor)+1);
                            if(currentImage != src) {
                                currentImage = src;
                                svgImage.element.attr('href', svgImage['x' + src]);
                            }
                        };
                    })(),
                    eventMagnet : $$('#mapMagnet')
                }).zoomIn().zoomOut();

                if(currentFloor == deviceFloor && !isLocationMode) {
                    drawCurrentLocation();
                }

                if(showFloorSwitcher) {
                    $$('#mapFloor').text(currentFloor + App.utils.getNumberSuffix(currentFloor));
                }
            });

            $$('.floorSwitcher').click(function() {
                self.trigger('changefloor', [$(this).data('floor')]);
            });

            if(showFloorSwitcher) {
                self.addClass('showFooter');
            }
            if(isLocationMode) {
                self.addClass('showHeader');
                $$('#saveLocation').show();
            }

            switch(data.mode) {
                case 'location' :
                    (function() {
                        var start = 0;
                        var sourcePoint = data.fromAdmin ? data.device.location : App.global('map_source');
                        var floor = data.fromAdmin ? data.device.floor : App.global('map_floor');

                        if(!floor) {
                            floor = floorNumbers[0];
                        }
                        self.trigger('changefloor', [Number(floor)]);
                        if(sourcePoint) {
                            var p = sourcePoint.split(',').map(Number);
                            layoutControl.circle((p[0] + 0.5) * unit.x, (p[1] + 0.5) * unit.y, Math.min(unit.x, unit.y)/2).attr({
                                id : 'sourcePoint'
                            });
                        }

                        self.on('mousedown touchstart', '#floorMap', function(e) {
                            start = Date.now();
                        });
                        self.on('mouseup touchend', '#floorMap', function(e) {
                            if(Date.now() - start > 100) {
                                return;
                            }

                            $$('#sourcePoint').remove();

                            var offset = App.utils.getOffsetFromEvent(e, this);
                            var viewBox = $(this).attr('viewBox').split(' ');
                            var zoomFactor = (dimensions.width / viewBox[2] + dimensions.height / viewBox[3])/2;

                            //Adjust zoom
                            offset.x /= zoomFactor;
                            offset.y /= zoomFactor;

                            //Adjust Pan
                            offset.x += +viewBox[0];
                            offset.y += +viewBox[1];

                            offset.x = Math.floor(offset.x/unit.x);
                            offset.y = Math.floor(offset.y/unit.y);

                            sourcePoint = offset.x + ',' + offset.y;

                            offset.x = (offset.x+0.5) * unit.x;
                            offset.y = (offset.y+0.5) * unit.y;

                            layoutControl.circle(offset.x, offset.y, Math.min(unit.x, unit.y)/2).attr({
                                id : 'sourcePoint'
                            });
                        });

                        $$('#saveLocation').click(function(e){
                            if(sourcePoint) {
                                App.button(this).load().textContent('Saving Location');
                                if(data.fromAdmin) {
                                    App.api.call('/device.edit', {
                                        id : data.device.id,
                                        store_id : data.device.store.id,
                                        location : sourcePoint,
                                        floor : currentFloor
                                    }, function(response) {
                                        App.notify('success', 'Successfully set location for device ' + (data.device.name || 'Device ' + data.device.id));
                                        var retailer = App.global('retailer');
                                        retailer.devices.data = retailer.devices.data.map(function(device) {
                                            return device.id == response.id ? response : device;
                                        });
                                        App.page.resetHistory();
                                        App.page.render('dashboard', retailer);
                                    }, function(message) {
                                        App.notify('error', message);
                                    });
                                } else {
                                    App.database.set({
                                        'map_source': sourcePoint,
                                        'map_floor' : currentFloor
                                    }).then(function(){
                                        location.reload();
                                    });
                                }
                            } else {
                                App.notify('error', 'Please set the location of device before saving !!');
                            }
                        });
                    })();
                    break;
                case 'order':
                    (function() {
                        self.trigger('changefloor', [deviceFloor]);

                        var pathGroup = layoutControl.g();
                        var marker = layoutControl.circle(0, 0, 3).attr({
                            id :'zopCircle'
                        });

                        var orderPaths = data.paths.map(function(path){
                            return path.map(getCenter);
                        });

                        drawOrderPath(orderPaths, pathGroup, marker);
                    })();
                    break;
                default:
                    self.trigger('changefloor', [deviceFloor]);
                    if(data.mode == 'path' || data.mode == 'multipath') {
                        if(data.mode == 'path') {
                            // wrapping source, destination and path inside a bounding box
                            var source = App.global('map_source').split(',').map(Number);
                            var dest = data.rack[0].map(Number);
                            // bounding box width
                            var width = Math.abs(source[0] - dest[0]) * unit.x;
                            // bounding box height
                            var height = (Math.abs(source[1] - dest[1])) * unit.y;
                            var zoomFactorX = Number(dimensions.width/width);
                            var zoomFactorY = Number(dimensions.height/height);
                            zoomingFactor = -Math.min(zoomFactorX, zoomFactorY);
                            // top left point in the bounding box
                            var topLeft = [Math.min(source[0], dest[0]) * unit.x, Math.min(source[1], dest[1]) * unit.y];
                            panzoom.zoomIn(null, zoomingFactor+1);
                            var viewBox = panzoom.getViewBox();
                            panzoom.panLeft(viewBox.x - topLeft[0]);
                            panzoom.panUp(viewBox.y - topLeft[1]);
                        }
                        data.rack.forEach(generatePath);
                    }
            }


            //Draw current location on the map
            function drawCurrentLocation() {
                var locationIcon = 'data:image/png;base64,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';
                var source = App.global('map_source').split(',').map(Number);
                layoutControl.image(locationIcon, (source[0] * unit.x) - 17, Math.max((source[1] * unit.y) - 28, 0), 34, 34);
            }

            //Update given floor change button based on given floor index
            function updateFloorButton(button, index) {
                var floor = floorNumbers[index];
                if(typeof floor != 'undefined') {
                    $$(button).show()
                        .data('floor', floor)
                        .find('span').text(floor + App.utils.getNumberSuffix(floor));
                } else {
                    $$(button).hide();
                }
            }

            //Get shortest path/s for given frontPoints and draw those paths
            function generatePath(frontPoints) {
                var result = pathfinder.getPath(canvas, App.global('map_source').split(','), frontPoints);
                //Get center of each cell from the path, source and target in pixel values
                result.path = result.path.map(getCenter);
                drawPath(result.path);
            }

            //Draw path using the given path points
            function drawPath(path, extraAttributes) {
                var attributes = $.extend(true, {
                    class : 'routePath'
                }, extraAttributes || {});

                path = getPath(path);

                var sourcePoint = layoutControl.circle(path.source.x, path.source.y, 3).attr({
                    class : 'orderPoint'
                });
                var targetPoint = layoutControl.circle(path.target.x, path.target.y, 3).attr({
                    class : 'orderPoint'
                });

                //generate path from the points
                var routePath = layoutControl.path(Snap.format("M{start} L {pointstring}", path)).attr(attributes);

                //Blips
                var duration = routePath.getTotalLength() * 7.5;
                blip(sourcePoint, duration, true);
                blip(targetPoint, duration, false);

                routePath = $(routePath.node);
                App.utils.queue(function(){
                    routePath.addClass('active');
                }, 15000);
                return routePath;
            }

            //Animate a point for given time
            function blip(point, duration, remove, iteration) {
                var end = iteration ? duration : Date.now() + duration;
                if(end > Date.now()) {
                    point.animate({r: 12, opacity : 0.4}, 500, mina.easeinout);
                    App.utils.queue(function() {
                        point.animate({r: 3, opacity : 1}, 500, mina.easeinout);
                        App.utils.queue(function() {
                            blip(point, end, remove, true);
                        }, 500);
                    }, 500);
                } else if(remove) {
                    $(point.node).remove();
                }
            }

            //Get center of given cell
            function getCenter(x, y) {
                var isObject = typeof x.x != 'undefined';
                var isGridNode = typeof x.weight != 'undefined';
                y = isObject ? x.y : y;
                x = isObject ? x.x : x;
                if(isObject && isGridNode) {
                    x = x + 0.5;
                    y = y + 0.5;
                }
                return {
                    x : x*unit.x,
                    y : y*unit.y
                };
            }

            //Generate path string from the given points
            function getPath(routePoints) {
                var source = routePoints.shift();
                var target = routePoints[routePoints.length - 1];
                var obj = {
                    start : source.x + ',' + source.y,
                    source : source,
                    target : target,
                    pointstring : []
                };
                routePoints.forEach(function(point){
                    obj.pointstring.push(point.x + ',' + point.y);
                });
                obj.pointstring = obj.pointstring.join(' ');
                return obj;
            }

            //Draw orderpath with animations
            function drawOrderPath(paths, group, marker) {
                var path = paths.shift();
                var routePath = drawPath(path);
                group.append(routePath[0]);

                animatePath(routePath[0], marker, function() {
                    if(paths.length) {
                        drawOrderPath(paths, group, marker);
                    }
                });
            }

            //Path animation for order sequencing
            function animatePath(path, marker, callback) {
                var start = null;
                var pathLength = path.getTotalLength();
                if(!pathLength) {
                    return callback();
                }

                var totalTime = pathLength * 7.5;
                function pathAnimation(timestamp) {
                    if (!start) {
                        start = timestamp;
                    }
                    var progress = timestamp - start;
                    var p = path.getPointAtLength((progress/totalTime) * pathLength);
                    marker.attr("transform", "translate(" + (p.x) + "," + (p.y) + ")");
                    if(progress < totalTime) {
                        window.requestAnimationFrame(pathAnimation);
                    } else {
                        callback();
                    }
                }
                window.requestAnimationFrame(pathAnimation);
            }
        },
        footer : function(data) {
            return data.fromAdmin || data.mode != 'location';
        }
    };
});
